import React from 'react';
import { BLUEPRINT_SPACE_FROM_LEFT } from '../../../constants/common.constants';
import { ICustomComponentProps, TConnectionGroupDetails } from '../../../api/blueprints/blueprint-details.types';

const BlueprintDetailsCustomConnectionGroups = ({
    values,
}: Partial<ICustomComponentProps>) => {
    return (
        <>
            {
                (values as TConnectionGroupDetails[]).map(({label, connectionsLabels}, index) => {
                    return (
                        <div key={index} className='blueprint-details--settings-item'>
                            <div
                                className='blueprint-details--settings-item__title wrap-word'
                            >
                                { label }
                            </div>
                            {
                                connectionsLabels.map((connectionLabel, idx) => {
                                    return (
                                        <div
                                            className={`p-left-${BLUEPRINT_SPACE_FROM_LEFT * 2}px blueprint-list-item wrap-word`}
                                            key={connectionLabel + idx}
                                        >
                                            { connectionLabel }
                                        </div>
                                    );
                                })
                            }
                        </div>
                    );
                })
            }
        </>
    );
};

export default BlueprintDetailsCustomConnectionGroups;
